/* eslint-disable max-len */
import React from 'react';
import {
  Card, Spin, Radio,
} from 'antd';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import {
  ResponsiveContainer,
} from 'recharts';
import { useTranslation } from 'react-i18next';

import CenteredContent from '@common/components/ui/CenteredContent';
import useBatterySoc from './useBatterySoc';
import styles from './BatterySoc.module.less';

function BatterySoc(props) {

  const { t } = useTranslation();
  const { className } = props;
  const {
    loading, optionsGraph, series, typeGraph,
    handleSelectGraph, selectGraph, constants,
  } = useBatterySoc();

  return (
    <Card className={className} style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)', height: 500 }}>
      <div className={styles.wapperBtn}>
        <Radio.Group value={selectGraph} onChange={handleSelectGraph} className={styles.btnGroup} disabled={loading}>
          <Radio.Button value={constants.SOC_CONSULT}>{t('views.device_graphics.battery_soc.soc')}</Radio.Button>
          <Radio.Button value={constants.BATTERY_CONSULT}>{t('views.device_graphics.battery_soc.battery')}</Radio.Button>
        </Radio.Group>
      </div>
      {(() => {

        if (loading) {

          return (
            <CenteredContent heightContainer="400px">
              <Spin tip={t('views.device_graphics.loading_data_graphs')} />
            </CenteredContent>
          );

        }

        return (
          <>
            <ResponsiveContainer width="95%" height={400}>
              <Chart
                className="container-graph-third"
                options={optionsGraph}
                series={series}
                width="100%"
                type={typeGraph}
                // height={100}
              />
            </ResponsiveContainer>
          </>
        );

      })()}
    </Card>
  );

}

BatterySoc.propTypes = {
  className: PropTypes.string,
};

BatterySoc.defaultProps = {
  className: null,
};

export default BatterySoc;
